<template>
  <RouterView></RouterView>
</template>

<script setup>
import { watch } from 'vue';
import { useRoute } from 'vue-router';
// route 
const route = useRoute()
// watch
watch(route, (next) => {
    setTitle(next)
}, {
    deep: true
})
// タイトル設定
const setTitle = (route) => {
  if (route.meta.title) {
    document.title = route.meta.title
  }
}
</script>

<style lang="scss">
#app {
    font-family: 'メイリオ', 'Meiryo', 'Hiragino Kaku Gothic ProN', 'ヒラギノ角ゴ ProN W3', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #515a6e;
}
</style>
